/*
 * @Description: 用户相关接口
 * @Author: ZY
 * @Date: 2020-12-28 14:40:50
 * @LastEditors: scy😊
 * @LastEditTime: 2021-01-20 10:17:09
 */
import { RootObject } from '@/model/rootObject'
import {
  PermissionPageModel,
  PermissionViewModel,
  PermissionPageParamModel,
  PermissionCreateModel,
  PermissionModel,
  PermissionListParamModel
} from '@/model/permission'
import { RolePermissionViewModel } from '@/model/roleModel'
import https from '@/utils/https'
import { ContentType, Method } from 'axios-mapper'

export const allPermissionList = (param: PermissionListParamModel) => {
  return https().request<RootObject<RolePermissionViewModel[]>>('/base/user/permission/list/all', Method.POST, param, ContentType.json)
}

export const getPermissionListForPage = (param: PermissionPageParamModel) => {
  return https().request<RootObject<PermissionPageModel>>('/base/user/permission/list/parent', Method.POST, param, ContentType.json)
}

export const getlistByPermissionLv = (permissionLv: number) => {
  return https().request<RootObject<PermissionViewModel[]>>('/base/user/permission/list/' + permissionLv, Method.GET, undefined, ContentType.json)
}

export const addPermission = (param: PermissionCreateModel) => {
  return https().request<RootObject<number>>('/base/user/permission/add', Method.POST, param, ContentType.json)
}

export const editPermission = (param: PermissionModel) => {
  return https().request<RootObject<number>>('/base/user/permission/edit', Method.POST, param, ContentType.json)
}

export const deletePermission = (permissionId: number) => {
  return https().request<RootObject<number>>('/base/user/permission/delete/' + permissionId, Method.POST, undefined, ContentType.json)
}
